import { getAnonymousAccountNumber } from "@common/helpers/bankAccount";
import { SubaccountSchema } from "@common/schemas/subaccount.schema";

export function getSubaccountDisplayName(
    subaccount: Pick<SubaccountSchema, "name" | "accountNumber">,
): string {
    const name = subaccount.name ?? "";

    if (/\d{4}$/.test(name) || !subaccount.accountNumber) {
        return name;
    }

    return `${name} ${getAnonymousAccountNumber(subaccount.accountNumber, 2)}`;
}
